/**
 * Получает значение указанного cookie из переданной строки со всеми cookies.
 *
 * @param {string} name - Имя cookie, значение которого нужно получить.
 * @param {string} cookie - Вся строка cookie.
 * @param {'cookie' | 'set-cookie'} type - Нужно для того, чтобы правильно выносить нужное значение из строки.
 * @returns {string|null} - Значение cookie, если оно найдено, иначе `null`.
 */
export function getCookie(name: string, cookie: string, type: 'cookie' | 'set-cookie'): string | null {
  if (!cookie) return null;

  if (type === 'cookie') {
    return (
      cookie
        .split('; ')
        .find(item => item.startsWith(`${name}=`))
        ?.replace(`${name}=`, '') || null
    );
  }

  if (type === 'set-cookie') {
    const cookieArray = cookie.split(';').filter(item => item.includes(`${name}=`));

    for (const item of cookieArray) {
      return item
        .trim()
        .split(',')
        .filter(item => item.includes(`${name}=`))[0]
        .trim()
        .replace(`${name}=`, '');
    }
  }

  return null;
}
